import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=769ec03e&scoped=true&"
import script from "./recordDetail.vue?vue&type=script&lang=js&"
export * from "./recordDetail.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=769ec03e&prod&lang=scss&"
import style1 from "./recordDetail.vue?vue&type=style&index=1&id=769ec03e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ec03e",
  null
  
)

export default component.exports